<template>
    <div class="thousand_layout" id="ValutBox" v-loading="loading">

        <div class="right_box">
            <div class="flex_layout_between">
                <h3>{{$t('vault.CardHobbyVault')}}</h3>
                <!-- <div class="flex_input">
                    <el-input ref="ifSellingCounts" :placeholder="$t('alert.searchWatchlist')" v-model="sn"
                        class="input-with-select" @change="getWatchlist">
                    </el-input>
                    <el-button slot="append" @click="getWatchlist" icon="el-icon-search"></el-button>
                </div> -->
            </div>
            <div class="breadcrumb">
                <router-link class="text_gray" :to="{ path: '/vault/buyerpanel' }">{{$t('vault.CardHobbyVault')}}</router-link> 
                <span class="el-icon-arrow-right text_gray"></span> 
                {{$t('vault.InVault')}}</div>
            <div class="bids_tabs">
                <div><router-link :to="{ path: '/vault/StockInMgt/'+vaultWareId }">{{$t('vault.SubmittoVault')}}</router-link></div>
                <div class="on"><router-link :to="{ path: '/vault/myvault/'+vaultWareId }">{{$t('vault.InVault')}}</router-link></div>
                <div><router-link :to="{ path: '/vault/OutboundList/'+vaultWareId }">{{$t('vault.WithdrawfromVault')}}</router-link></div>
            </div>

            <div class="flex_layout_between">
                <div class="status_tabs">
                    <span :class="{ 'active': vaultType == 0 }" v-on:click="vaultType = 0">{{$t('vault.NotConsigned')}}</span>
                    <span :class="{ 'active': vaultType == 5 }" v-on:click="vaultType = 5">{{$t('vault.Consigned')}}</span>
                    <span :class="{ 'active': vaultType == 1 }" v-on:click="vaultType = 1">{{$t('base.bids')}}</span>
                    <span :class="{ 'active': vaultType == 4 }" v-on:click="vaultType = 4">{{$t('vault.Sold')}}</span>
                </div>

                <div class="stockBtn" v-if="vaultType == 0">
                    <template v-if="valutList && valutList.length > 0">
                        <router-link  class="tab-btn puton" :to="{ path: '/vault/Outbound/'+vaultWareId }">{{$t('vault.WithdrawCards')}}</router-link>
                    </template>
                    <div class="tab-btn entrust-sale" v-show="entrustSaleBtnShow" v-on:click="SetVaultEntrustSale()">
                        {{$t('vault.ConsignforSale')}}
                    </div>
                </div>
                <!-- 搜索 -->
                <div class="search-box" v-if="[5, 1].includes(vaultType)">
                    <!-- 代卖委托人 -->
                    <el-select v-model="SellerUserId" slot="prepend" v-if="[5].includes(vaultType)" filterable :placeholder="$t('vault.Consigner')" v-on:change="PageIndex = 1; getData('GetCommodityByMemberId')" popper-class="resale-select-box" clearable>
                        <el-option v-for="item in sellingList" :key="item.RealName" :label="item.RealName" :value="item.SellerUserId">
                            <div class="resale-row">
                                <div class="ent-avatar">
                                    <el-image class="avatar-img" :src="`${item.Photo || '/static/images/avatar.png'}?imageView2/2/h/100`" fit="contain">
                                    </el-image>
                                </div>
                                <div class="resale--middle">
                                    <div class="resale---info">
                                        <div>{{ item.RealName }}</div>
                                        <div class="txt-gray">{{$t('vault.positive')}}: {{ item.PositiveCount }}</div>
                                    </div>
                                    <div class="my-resale">{{$t('vault.MyConsignments')}}：{{ item.CommodityCount }}&nbsp;<img src="/static/images/icon/arrow-right.png" width="12" /></div>
                                </div>
                            </div>
                        </el-option>
                    </el-select>
                    <!-- 商品名 -->
                    <el-input :placeholder="$t('base.item')" v-model="Title" class="" style="width: 300px;">
                        <el-button slot="append" icon="el-icon-search" v-on:click="getValut(vaultType)"></el-button>
                    </el-input>
                </div>
                <!-- /搜索 -->
            </div>

            <!-- 未委托/委托 -->
            <template v-if="vaultType == 0 || vaultType == 5">
                <div class="vault_list_box">
                    <div class="headlist">
                        <div class="first">{{$t('base.item')}}</div>
                        <div>{{$t('vault.EstimatedValue')}}</div>
                        <div>{{$t('base.status')}}</div>
                        <div>{{$t('base.operate')}}</div>
                    </div>
                    <div class="content_list" v-for="(item, index) in valutList" :key="index">
                        <div class="first">
                            <div class="pickupCard">
                                <div class="pickupCardImg">
                                    <el-image class="img-box" :src="item.TitImg + '?imageView2/2/w/350'" fit="contain"></el-image>
                                </div>
                                <div class="pickupCardText">
                                    <strong class="line-clamp-2">{{ item.Title }}</strong>
                                    <div>{{ item.ProfessionalGrader }} {{ item.Grade }}</div>
                                </div>
                            </div>
                        </div>
                        <div>USD {{ ThousandAndDecimal(item.UsdPrice||priceExchange(item.Price)) }}</div>
                        <div class="" :class="{'text_red': (item.ApplyStatus == 1),'text_greed': (item.ApplyStatus == 2)}">
                        <span>{{ SetStatusEnumVal(item, "inStock").label }}</span>
                        <span v-if="item.SellerDateTime&&item.ApplyStatus==1" class="history_time" style="display: block;">{{$t('colon.remaining')}} {{ ApplicationPending(item.SellerDateTime,nowData) }}</span>
                        </div>
                        <div class="last">
                            <!-- <button type="button" class="kt-play-btn btn-01 puton" v-on:click="getDetail(item)">详情</button> -->
                            <el-link v-on:click="getDetail(item)">{{ $t('base.viewDetails') }}</el-link>
                        </div>
                    </div>
                </div>
            </template>


            <!-- 竞拍 -->
            <template v-if="vaultType == 1">

                <div>
                    <div class="status_tabs status_bids_tabs">
                        <span :class="{ 'active': (SortType == 1) }" v-on:click="SortType = 1">{{$t('enum.endingSoonest')}}</span>
                        <span :class="{ 'active': (SortType == 2) }" v-on:click="SortType = 2">{{$t('enum.newlyListed')}}</span>
                        <span :class="{ 'active': (SortType == 3) }" v-on:click="SortType = 3">{{$t('enum.highToLow')}}</span>
                        <span :class="{ 'active': (SortType == 4) }" v-on:click="SortType = 4">{{$t('enum.lowToHigh')}}</span>
                    </div>
                </div>
                <div class="vault_list_box outbund">
                    <div class="headlist">
                        <div class="first">{{$t('base.item')}}</div>
                        <div>{{$t('base.price')}}</div>
                        <div class="type">{{$t('vault.Type')}}
                        </div>
                        <div>{{$t('vault.EndTime')}}</div>
                        <div>{{$t('base.operate')}}</div>
                    </div>
                    <div class="content_list" v-for="(item, index) in valutList" :key="index">
                        <div class="first">
                            <div class="pickupCard">
                                <div class="pickupCardImg">
                                    <el-image class="img-box" :src="item.TitImg + '?imageView2/2/w/350'" fit="contain"></el-image>
                                </div>
                                <div class="pickupCardText">
                                    <strong class="line-clamp-2">{{ item.Title }}</strong>
                                    <div>{{ item.ProfessionalGrader }} {{ item.Grade }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- ***************************************************************************** -->
                        <div>USD {{ ThousandAndDecimal(item.UsdPrice||priceExchange(item.Price)) }}</div>
                        <!-- ***************************************************************************** -->
                        <div class="type">
                            <div>{{ $t('base.bids') }}</div>
                            <div>{{item.PriceCount}} {{ $t('base.bids') }}</div>
                        </div>
                        <div>{{setTime(item.EffectiveDate)}}</div>
                        <div class="last">
                            <el-link v-on:click="getDetail(item)">{{ $t('base.viewDetails') }}</el-link>
                        </div>
                    </div>
                </div>
            </template>



            <!-- 已售出 -->
            <template  v-if="vaultType == 4">
                <div>
                    <div class="status_tabs status_bids_tabs">
                        <span :class="{ 'active': (SellCommodityType === 21) }" v-on:click="SellCommodityType = 21">{{$t('base.all')}}</span>
                        <span :class="{ 'active': (SellCommodityType === 1) }" v-on:click="SellCommodityType = 1">{{$t('base.unpaid')}}</span>
                        <span :class="{ 'active': (SellCommodityType === 5) }" v-on:click="SellCommodityType = 5">{{$t('base.finished')}}</span>
                        <!-- <span :class="{ 'active': (SellCommodityType === 6) }" v-on:click="SellCommodityType = 6">{{$t('base.closed')}}</span> -->
                    </div>
                </div>
                <div class="vault_list_box outbund">
                    <div class="headlist">
                        <div class="first">{{$t('base.item')}}</div>
                        <div class="type">{{$t('base.quantity')}}</div>
                        <div>{{$t('vault.FinalPrice')}}</div>
                        <div>{{$t('vault.SoldPrice')}}</div>
                        <div>{{$t('base.operate')}}</div>
                    </div>
                </div>
                <div class="order_list" v-for="(item, index) in valutList" :key="index">
                    <div class="history_list">
                        <div><span class="text_gray">{{$t('colon.orderNumber')}}</span> {{item.Code}}</div>
                        <div class="avatar_box">
                            <el-avatar class="avatar" :size="16" :src="item.SellerHeadPortrait"></el-avatar>
                            <router-link tag='em' :to="{path:'/seller/detail/'+item.SellerWyAccId}">{{item.SellRealName}} ({{item.SellerIntegral}})<span class="earth" :class="item.SellMemberSource"></span></router-link>
                        </div>
                    </div>
                    <div class="vault_list_box outbund soldList" v-for="(obj, num) in item.Details" :key="num">
                        <div class="content_list ">
                            <div class="first">
                                <div class="pickupCard">
                                    <div class="pickupCardImg">
                                        <el-image class="img-box" :src="obj.TitImg + '?imageView2/2/w/350'" fit="contain"></el-image>
                                    </div>
                                    <div class="pickupCardText">
                                        <div class="line-clamp-2">{{ obj.Title }}</div>
                                        <div class="text_gray">{{$t('vault.ItemCode')}}: {{obj.Code}}</div>
                                    </div>
                                </div>
                                <div class="type">x {{obj.QuantitySold}}</div> 
                            </div>
                            <div>{{cardOwnPrice(item)}}</div> 
                            <div>USD {{item.USD_TotalPrice}}</div> 
                            <div>
                                <router-link target="_blank" :to="{ path:`/mycardhobby/detail/${item.ID}`}">{{$t('base.viewDetails')}}</router-link>
                            </div> 
                        </div>
                    </div>
                </div>
            </template>
            <not-null class="notfind" title="" :text="$t('base.noData')" v-if="isCount" />
            <list-pagination class="" :TotalCount="pageTotal" :ps="PageIndex" @ps='sizeChange' @pi='currentChange' />
            <!-- <div class="block_pagination">
                <el-pagination v-on:size-change="sizeChange" :hide-on-single-page="true" v-on:current-change="currentChange" :current-page.sync="PageIndex" :page-size="PageSize" layout="total, prev, pager, next" :total="pageTotal"></el-pagination>
            </div> -->


            <!-- @* #region 委托代卖 *@ -->
            <vault-entrust-sale ref="VaultEntrustSale" v-if="entrustSaleShow" :vaultDetail="itemDetail" :VaultId="vaultWareId" @handleRefreshCommodity="handleRefreshCommodity"></vault-entrust-sale>
            <!-- @* #endregion *@ -->

            <!-- @* #region 商品详情 *@ -->
            <vault-detail v-if="dislogType.vaultDetails" :vaultDetail="itemDetail" :cardDetail="cardDetail" :dialogVisible='dislogType.vaultDetails' @handleCardOperation="handleCardOperation" />
            <!-- @* #endregion *@ -->
        </div>



    </div>
</template>

<script>
import vueVault from './js/vue-Vault.js';
export default {
    ...vueVault
};
</script>


<style scoped>
@import "../../../static/css/usertabslist.css";
@import "../../../static/css/vault/vault.css";
.history_time::before{
    content: '';
	background: url(../../../static/images/icon/icon_timing_red.svg) no-repeat;
    width: 10px;
    height: 10px;
    display: inline-block;
    background-size: contain;
}
.last a+a{
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Vault/MyVault.vue